export const rolerecpos = {
  S: [
    { x: 10, y: 30 },
    { x: 36, y: 64 },
    { x: 68, y: 66 },
    { x: 82, y: 88 },
    { x: 38, y: 88 },
    { x: 32, y: 88 },
  ], // Setter
  OH1: [
    { x: 28, y: 40 },
    { x: 16, y: 33 },
    { x: 52, y: 30 },
    { x: 50, y: 30 },
    { x: 82, y: 40 },
    { x: 82, y: 38 },
  ], // Outside Hitter 1
  MB2: [
    { x: 52, y: 80 },
    { x: 11, y: 70 },
    { x: 22, y: 34 },
    { x: 22, y: 34 },
    { x: 52, y: 30 },
    { x: 90, y: 85 },
  ], // Middle Blocker 1
  OP: [
    { x: 84, y: 76 },
    { x: 33, y: 80 },
    { x: 16, y: 70 },
    { x: 12, y: 12 },
    { x: 33, y: 12 },
    { x: 68, y: 12 },
  ], // Opposite
  OH2: [
    { x: 80, y: 35 },
    { x: 80, y: 34 },
    { x: 80, y: 34 },
    { x: 80, y: 34 },
    { x: 24, y: 30 },
    { x: 50, y: 30 },
  ], // Outside Hitter 2
  MB1: [
    { x: 51, y: 30 },
    { x: 50, y: 23 },
    { x: 88, y: 82 },
    { x: 78, y: 65 },
    { x: 20, y: 65 },
    { x: 25, y: 38 },
  ], // Middle Blocker 2
};

export const rolerecopppos = {
  S: [
    { x: 12, y: 52 },
    { x: 48, y: 66 },
    { x: 86, y: 66 },
    { x: 90, y: 82 },
    { x: 50, y: 88 },
    { x: 30, y: 88 },
  ], // Setter
  OH1: [
    { x: 16, y: 68 },
    { x: 16, y: 33 },
    { x: 70, y: 30 },
    { x: 76, y: 30 },
    { x: 82, y: 66 },
    { x: 82, y: 62 },
  ], // Outside Hitter 1
  MB2: [
    { x: 52, y: 80 },
    { x: 11, y: 70 },
    { x: 48, y: 30 },
    { x: 52, y: 16 },
    { x: 80, y: 33 },
    { x: 90, y: 85 },
  ], // Middle Blocker 1
  OP: [
    { x: 82, y: 34 },
    { x: 30, y: 82 },
    { x: 18, y: 40 },
    { x: 24, y: 24 },
    { x: 50, y: 16 },
    { x: 70, y: 32 },
  ], // Opposite
  OH2: [
    { x: 52, y: 29 },
    { x: 78, y: 40 },
    { x: 89, y: 42 },
    { x: 76, y: 48 },
    { x: 22, y: 32 },
    { x: 48, y: 30 },
  ], // Outside Hitter 2
  MB1: [
    { x: 30, y: 32 },
    { x: 55, y: 30 },
    { x: 90, y: 82 },
    { x: 82, y: 65 },
    { x: 12, y: 66 },
    { x: 23, y: 33 },
  ], // Middle Blocker 2
};

export const roleorigpos = {
  S: [
    { x: 16, y: 12 },
    { x: 50, y: 33 },
    { x: 82, y: 33 },
    { x: 82, y: 70 },
    { x: 50, y: 70 },
    { x: 16, y: 70 },
  ],
  OH1: [
    { x: 16, y: 70 },
    { x: 16, y: 12 },
    { x: 50, y: 33 },
    { x: 82, y: 33 },
    { x: 82, y: 70 },
    { x: 50, y: 70 },
  ],
  MB2: [
    { x: 50, y: 70 },
    { x: 16, y: 70 },
    { x: 16, y: 12 },
    { x: 50, y: 33 },
    { x: 82, y: 33 },
    { x: 82, y: 70 },
  ],
  OP: [
    { x: 82, y: 70 },
    { x: 50, y: 70 },
    { x: 16, y: 70 },
    { x: 16, y: 12 },
    { x: 50, y: 33 },
    { x: 82, y: 33 },
  ],
  OH2: [
    { x: 82, y: 33 },
    { x: 82, y: 70 },
    { x: 50, y: 70 },
    { x: 16, y: 70 },
    { x: 16, y: 12 },
    { x: 50, y: 33 },
  ],
  MB1: [
    { x: 50, y: 33 },
    { x: 82, y: 33 },
    { x: 82, y: 70 },
    { x: 50, y: 70 },
    { x: 16, y: 70 },
    { x: 16, y: 12 },
  ],
};

export const rolebasepos = {
  S: [
    { x: 16, y: 33 },
    { x: 16, y: 33 },
    { x: 16, y: 33 },
    { x: 0, y: 88 },
    { x: 0, y: 88 },
    { x: 0, y: 88 },
  ], // Setter
  OH1: [
    { x: 100, y: 88 },
    { x: 50, y: 30 },
    { x: 50, y: 30 },
    { x: 50, y: 30 },
    { x: 100, y: 88 },
    { x: 100, y: 88 },
  ], // Outside Hitter 1
  MB2: [
    { x: 50, y: 88 },
    { x: 50, y: 88 },
    { x: 82, y: 33 },
    { x: 82, y: 33 },
    { x: 82, y: 33 },
    { x: 50, y: 88 },
  ], // Middle Blocker 1
  OP: [
    { x: 0, y: 88 },
    { x: 0, y: 88 },
    { x: 0, y: 88 },
    { x: 16, y: 33 },
    { x: 16, y: 33 },
    { x: 16, y: 33 },
  ], // Opposite
  OH2: [
    { x: 50, y: 30 },
    { x: 100, y: 88 },
    { x: 100, y: 88 },
    { x: 100, y: 88 },
    { x: 50, y: 30 },
    { x: 50, y: 30 },
  ], // Outside Hitter 2
  MB1: [
    { x: 82, y: 33 },
    { x: 82, y: 33 },
    { x: 50, y: 88 },
    { x: 50, y: 88 },
    { x: 50, y: 88 },
    { x: 82, y: 33 },
  ], // Middle Blocker 2
};

export const roleattpos = {
  S: [
    { x: 32, y: 80 },
    { x: 32, y: 80 },
    { x: 32, y: 80 },
    { x: 32, y: 80 },
    { x: 32, y: 80 },
    { x: 32, y: 80 },
  ],
  OH1: [
    { x: 100, y: 70 },
    { x: 50, y: 33 },
    { x: 50, y: 33 },
    { x: 50, y: 33 },
    { x: 100, y: 70 },
    { x: 100, y: 70 },
  ],
  MB2: [
    { x: 55, y: 80 },
    { x: 55, y: 80 },
    { x: 84, y: 40 },
    { x: 84, y: 40 },
    { x: 84, y: 40 },
    { x: 55, y: 80 },
  ],
  OP: [
    { x: 0, y: 70 },
    { x: 0, y: 70 },
    { x: 0, y: 70 },
    { x: 16, y: 40 },
    { x: 16, y: 40 },
    { x: 16, y: 40 },
  ],
  OH2: [
    { x: 50, y: 33 },
    { x: 100, y: 70 },
    { x: 100, y: 70 },
    { x: 100, y: 70 },
    { x: 50, y: 33 },
    { x: 50, y: 33 },
  ],
  MB1: [
    { x: 84, y: 40 },
    { x: 84, y: 40 },
    { x: 55, y: 80 },
    { x: 55, y: 80 },
    { x: 55, y: 80 },
    { x: 84, y: 40 },
  ],
}

export const roleattopppos = {
  S: [
    { x: 32, y: 80 },
    { x: 32, y: 80 },
    { x: 32, y: 80 },
    { x: 32, y: 80 },
    { x: 32, y: 80 },
    { x: 32, y: 80 },
  ],
  OH1: [
    { x: 100, y: 70 },
    { x: 50, y: 33 },
    { x: 50, y: 33 },
    { x: 50, y: 33 },
    { x: 100, y: 70 },
    { x: 100, y: 70 },
  ],
  MB2: [
    { x: 55, y: 80 },
    { x: 55, y: 80 },
    { x: 84, y: 40 },
    { x: 84, y: 40 },
    { x: 84, y: 40 },
    { x: 55, y: 80 },
  ],
  OP: [
    { x: 0, y: 70 },
    { x: 0, y: 70 },
    { x: 0, y: 70 },
    { x: 16, y: 40 },
    { x: 16, y: 40 },
    { x: 16, y: 40 },
  ],
  OH2: [
    { x: 50, y: 33 },
    { x: 100, y: 70 },
    { x: 100, y: 70 },
    { x: 100, y: 70 },
    { x: 50, y: 33 },
    { x: 50, y: 33 },
  ],
  MB1: [
    { x: 84, y: 40 },
    { x: 84, y: 40 },
    { x: 55, y: 80 },
    { x: 55, y: 80 },
    { x: 55, y: 80 },
    { x: 84, y: 40 },
  ],
}

export const rolesideoutopppos = {
  S: [
    { x: 32, y: 80 },
    { x: 32, y: 80 },
    { x: 32, y: 80 },
    { x: 32, y: 80 },
    { x: 32, y: 80 },
    { x: 32, y: 80 },
  ],
  OH1: [
    { x: 0, y: 70 },
    { x: 50, y: 33 },
    { x: 50, y: 33 },
    { x: 50, y: 33 },
    { x: 100, y: 70 },
    { x: 100, y: 70 },
  ],
  MB2: [
    { x: 55, y: 80 },
    { x: 55, y: 80 },
    { x: 84, y: 40 },
    { x: 84, y: 40 },
    { x: 84, y: 40 },
    { x: 55, y: 80 },
  ],
  OP: [
    { x: 100, y: 70 },
    { x: 0, y: 70 },
    { x: 0, y: 70 },
    { x: 16, y: 40 },
    { x: 16, y: 40 },
    { x: 16, y: 40 },
  ],
  OH2: [
    { x: 50, y: 33 },
    { x: 100, y: 70 },
    { x: 100, y: 70 },
    { x: 100, y: 70 },
    { x: 50, y: 33 },
    { x: 50, y: 33 },
  ],
  MB1: [
    { x: 84, y: 40 },
    { x: 84, y: 40 },
    { x: 55, y: 80 },
    { x: 55, y: 80 },
    { x: 55, y: 80 },
    { x: 84, y: 40 },
  ],
}

export const roleservepos = {
  S: [
    { x: 16, y: 10 },
    { x: 16, y: 33 },
    { x: 16, y: 33 },
    { x: 10, y: 88 },
    { x: 10, y: 88 },
    { x: 10, y: 88 },
  ], // Setter
  OH1: [
    { x: 90, y: 88 },
    { x: 50, y: 10 },
    { x: 50, y: 30 },
    { x: 50, y: 30 },
    { x: 90, y: 88 },
    { x: 90, y: 88 },
  ], // Outside Hitter 1
  MB2: [
    { x: 50, y: 88 },
    { x: 50, y: 88 },
    { x: 82, y: 10 },
    { x: 82, y: 33 },
    { x: 82, y: 33 },
    { x: 50, y: 88 },
  ], // Middle Blocker 1
  OP: [
    { x: 10, y: 88 },
    { x: 10, y: 88 },
    { x: 10, y: 88 },
    { x: 16, y: 10 },
    { x: 16, y: 33 },
    { x: 16, y: 33 },
  ], // Opposite
  OH2: [
    { x: 50, y: 30 },
    { x: 90, y: 88 },
    { x: 90, y: 88 },
    { x: 90, y: 88 },
    { x: 50, y: 10 },
    { x: 50, y: 30 },
  ], // Outside Hitter 2
  MB1: [
    { x: 82, y: 33 },
    { x: 82, y: 33 },
    { x: 50, y: 88 },
    { x: 50, y: 88 },
    { x: 50, y: 88 },
    { x: 82, y: 10 },
  ], // Middle Blocker 2
};
